import _get from "lodash/get";
import { hasExternalLegalOwner } from "./accountSelectors";
import { getTotalPriceUpfront, hasOnlyServiceSubscriptions } from "./cartSelectors";
import { State as CheckoutState } from "./checkout";
import { isOnlySubscriptionsToExistingCustomers, hasBroadbandInCart } from "./combinedSelectors";
import { getEnhancedDeliveryInfoSelected } from "./deliveryInfoSelectors";
import { getPaymentSelectedType } from "./paymentSelectors";
import { hasSubscriptions as hasSubscriptionsSelector } from "./subscriptionsSelectors";
import {
    PAYMENT_METHOD,
    CHECKOUT_LABELS_MBB_UPFRONT,
    CHECKOUT_LABELS_MBB,
    CHECKOUT_LINKS,
    CHECKOUT_LABELS_SUBSCRIPTIONS_GROUPED_EXTERNAL,
    CHECKOUT_LABELS_SUBSCRIPTIONS_GROUPED,
    CHECKOUT_LINKS_SUBSCRIPTIONS_GROUPED_EXTERNAL,
    CHECKOUT_LINKS_SUBSCRIPTIONS_GROUPED,
    CHECKOUT_LABELS_UPRONT_SUBSCRIPTIONS,
    CHECKOUT_LINKS_UPFRONT_SUBSCRIPTIONS,
    CHECKOUT_LABELS_NOSUBSCRIPTIONS,
    CHECKOUT_LINKS_SERVICE_SUBSCRIPTIONS,
    CHECKOUT_LABELS_SERVICE_SUBSCRIPTIONS,
} from "../../../../../constants";
import { StepIndicatorType } from "../../../../../models";

export type State = CheckoutState;
const getStepIndicatorData = (state: State): StepIndicatorType => {
    const hasSubscription = hasSubscriptionsSelector(state);
    const totalPriceUpfront = getTotalPriceUpfront(state);
    const selectedDeliveryMethod = getEnhancedDeliveryInfoSelected(state);
    const isUpfrontAndPayNow =
        totalPriceUpfront + _get(selectedDeliveryMethod, "price", 0) &&
        getPaymentSelectedType(state) !== PAYMENT_METHOD.INVOICE;
    const hasOnlyExistingSimOnly = isOnlySubscriptionsToExistingCustomers(state);

    if (hasOnlyServiceSubscriptions(state)) {
        return {
            hide: false,
            steps: 3,
            labels: CHECKOUT_LABELS_SERVICE_SUBSCRIPTIONS,
            links: CHECKOUT_LINKS_SERVICE_SUBSCRIPTIONS,
        };
    }

    if (hasBroadbandInCart(state)) {
        return {
            hide: false,
            steps: isUpfrontAndPayNow ? 4 : 3,
            labels: isUpfrontAndPayNow ? CHECKOUT_LABELS_MBB_UPFRONT : CHECKOUT_LABELS_MBB,
            links: CHECKOUT_LINKS,
        };
    }

    if (hasSubscription && !isUpfrontAndPayNow) {
        const gotExternalLegalOwner = hasExternalLegalOwner(state);

        return {
            hide: false,
            steps: gotExternalLegalOwner ? 5 : 4,
            labels: gotExternalLegalOwner
                ? CHECKOUT_LABELS_SUBSCRIPTIONS_GROUPED_EXTERNAL(hasOnlyExistingSimOnly)
                : CHECKOUT_LABELS_SUBSCRIPTIONS_GROUPED(hasOnlyExistingSimOnly),
            links: gotExternalLegalOwner
                ? CHECKOUT_LINKS_SUBSCRIPTIONS_GROUPED_EXTERNAL
                : CHECKOUT_LINKS_SUBSCRIPTIONS_GROUPED,
        };
    }

    if (isUpfrontAndPayNow && hasSubscription) {
        return {
            hide: false,
            steps: 5,
            labels: CHECKOUT_LABELS_UPRONT_SUBSCRIPTIONS(hasOnlyExistingSimOnly),
            links: CHECKOUT_LINKS_UPFRONT_SUBSCRIPTIONS,
        };
    }

    return {
        hide: false,
        steps: 4,
        labels: CHECKOUT_LABELS_NOSUBSCRIPTIONS,
        links: CHECKOUT_LINKS,
    };
};

export default getStepIndicatorData;
